export default __webpack_public_path__ + "static/media/Selfielocation_science.17f921a8.png";